import { applyMiddleware, createStore, combineReducers } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'

import { connectRealtime } from 'store/middleware/realtime'

import applicationInfo from 'store/reducers/applicationInfo'
import auth from 'store/reducers/auth'
import capacity from 'store/reducers/capacity'
import contactLists from 'store/reducers/contactLists'
import events from 'store/reducers/events'
import footer from 'store/reducers/footer'
import modals from 'store/reducers/modals'
import notifications from 'store/reducers/notifications'
import onboarding from 'store/reducers/onboarding'
import punchTerminal from 'store/reducers/punchTerminal'
import refresh from 'store/reducers/refresh'
import resources from 'store/reducers/resources'
import settings from 'store/reducers/settings'
import tables from 'store/reducers/tables'
import users from 'store/reducers/users'
import scheduleTemplates from 'store/reducers/scheduleTemplates'

export const store = createStore(
  combineReducers({
    applicationInfo,
    auth,
    capacity,
    contactLists,
    events,
    footer,
    modals,
    notifications,
    onboarding,
    punchTerminal,
    refresh,
    resources,
    scheduleTemplates,
    settings,
    tables,
    users
  }),
  composeWithDevTools(applyMiddleware(thunk, connectRealtime))
)
